import { render, staticRenderFns } from "./DefaultBurgerMenu.vue?vue&type=template&id=9d7f83f0&scoped=true&"
import script from "./DefaultBurgerMenu.vue?vue&type=script&lang=js&"
export * from "./DefaultBurgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./DefaultBurgerMenu.vue?vue&type=style&index=0&id=9d7f83f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7f83f0",
  null
  
)

export default component.exports